<template>
  <e-charts ref="line" autoresize :options="option" theme="theme-color" auto-resize
    :style="{ height: height + 'px', width: '100%' }" />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/custom'
import 'echarts/lib/component/dataZoom'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  computed: {
    option() {
      if (!this.optionData) {
        return {}
      }
      return {
        tooltip: this.optionData.tooltip || {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: this.optionData.legend || {
          left: 0,
        },
        grid: this.optionData.grid,
        xAxis: this.optionData.xAxis,
        yAxis: this.optionData.yAxis,
        series: this.optionData.series,
        dataZoom: this.optionData.dataZoom,
      }
    }
  }
}
</script>
